import React from 'react'

import SRModal from "../modal/modal"

const HelpUr = () => (
    <SRModal title={"Besoin d'aide ?"} text={"Besoin d'aide ?"}>
        <div className={"content content-modal"}>
            <p>Une question ?<br />Prenez contact avec nous. Nous serons heureux de vous aider !<br />
                <a href="mailto:registration-cfp@urevent.fr">registration-cfp2022@urevent.fr</a>
            </p>
        </div>
    </SRModal>
)
SRModal.propTypes = {
    text: "Besoin d'aide ?",
    title: "Besoin d'aide ?",
}
export default HelpUr
